import {z} from 'zod';

export const UserSelectorSchema = z.object({
	all: z.boolean(),
	emails: z.array(z.string()),
	groupIds: z.array(z.number()),
	none: z.boolean(),
	userIds: z.array(z.number()),
	userSelectorId: z.number().optional(),
});

export type IUserSelector = z.infer<typeof UserSelectorSchema>;

export const EnhancedUserSelectorSchema = UserSelectorSchema.omit({
	emails: true,
	groupIds: true,
	userIds: true,
}).extend({
	groups: z.array(
		z.object({
			groupId: z.number(),
			groupLabel: z.string(),
		}),
	),
	users: z.array(
		z.object({
			userId: z.number(),
			userLabel: z.string(),
		}),
	),
});

export type IEnhancedUserSelector = z.infer<typeof EnhancedUserSelectorSchema>;
